import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarTile } from "@perxis-auto/ui-kit/lib/components/CarTile";
const TileGallery = memo(function TileGallery2({ isLoading = false, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarTile.ImageSkeleton, {});
  }
  return /* @__PURE__ */ jsx(CarTile.Gallery, { ...props });
});
export {
  TileGallery
};
